import React, { useEffect, useState } from 'react';
import jsVectorMap from "jsvectormap";
import "jsvectormap/dist/maps/world.js";
import config from '../../config';
import { useAuth } from '../../context/AuthContext';

const countryMeta = {
    'China': { coords: [35.8617, 104.1954], code: 'CN' },
    'Australia': { coords: [-25.2744, 133.7751], code: 'AU' },
    'USA': { coords: [36.77, -119.41], code: 'US' },
    'United States': { coords: [36.77, -119.41], code: 'US' },
    'UK': { coords: [55.37, -3.41], code: 'GB' },
    'United Kingdom': { coords: [55.37, -3.41], code: 'GB' },
    'UAE': { coords: [25.20, 55.27], code: 'AE' },
    'United Arab Emirates': { coords: [25.20, 55.27], code: 'AE' },
    'Saudi Arabia': { coords: [23.8859, 45.0792], code: 'SA' },
};

const DistributionMapsOne = () => {
    const { token } = useAuth();
    const [countryData, setCountryData] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchCountryStats = async () => {
            if (!token) return;
            try {
                const response = await fetch(`${config.API_BASE_URL}/api/payments/country-stats`, {
                    headers: { 'Authorization': `Bearer ${token}` }
                });
                if (response.ok) {
                    const data = await response.json();
                    setCountryData(data.countries || []);
                }
            } catch (error) {
                console.error('Error fetching country stats:', error);
            } finally {
                setLoading(false);
            }
        };

        fetchCountryStats();
    }, [token]);

    useEffect(() => {
        if (loading) return;

        const markers = countryData.map(item => {
            const meta = countryMeta[item.name] || countryMeta['USA'];
            return {
                coords: meta.coords,
                name: `${item.name} : ${item.value}`
            };
        });

        const map = new jsVectorMap({
            selector: "#map",
            map: 'world',
            backgroundColor: 'transparent',
            borderColor: '#fff',
            borderOpacity: 0.25,
            borderWidth: 0,
            color: '#000000',
            regionStyle: {
                initial: {
                    fill: '#D1D5DB',
                },
            },
            markerStyle: {
                initial: {
                    r: 5,
                    'fill': '#fff',
                    'fill-opacity': 1,
                    'stroke': '#000',
                    'stroke-width': 1,
                    'stroke-opacity': 0.4
                },
            },
            markers: markers,
            series: {
                regions: [{
                    attribute: "fill",
                    scale: {
                        "US": '#487FFF',
                        "SA": '#FF9F29',
                        "AU": '#45B369',
                        "CN": '#F86624',
                        "GB": '#487FFF',
                        "AE": '#487FFF',
                    },
                    values: countryData.reduce((acc, item) => {
                        const meta = countryMeta[item.name];
                        if (meta) acc[meta.code] = meta.code;
                        return acc;
                    }, {})
                }]
            },
            hoverOpacity: null,
            normalizeFunction: 'linear',
            zoomOnScroll: false,
            scaleColors: ['#000000', '#000000'],
            selectedColor: '#000000',
            selectedRegions: [],
            enableZoom: false,
            hoverColor: '#fff',
        });

        return () => {
            map && map.destroy();
        };
    }, [loading, countryData]);

    return (
        <div className="col-xxl-4 col-lg-6">
            <div className="card radius-8 border-0">
                <div className="card-body">
                    <div className="d-flex align-items-center flex-wrap gap-2 justify-content-between">
                        <h6 className="mb-2 fw-bold text-lg">Distribution Maps</h6>
                        <div className="">
                            <select className="form-select form-select-sm w-auto bg-base border text-secondary-light" defaultValue="">
                                <option value="" disabled>
                                    Select Frequency
                                </option>
                                <option value="Yearly">Yearly</option>
                                <option value="Monthly">Monthly</option>
                                <option value="Weekly">Weekly</option>
                                <option value="Today">Today</option>
                            </select>
                        </div>
                    </div>
                </div>
                <div id="world-map"><div id="map" /></div>
                <div className="card-body p-24 max-h-266-px scroll-sm overflow-y-auto">
                    <div className="">
                        {loading ? (
                            <div className="text-center">Loading stats...</div>
                        ) : (
                            countryData.length > 0 ? (
                                countryData.map((item, index) => (
                                    <div key={index} className="d-flex align-items-center justify-content-between gap-3 mb-12 pb-2">
                                        <div className="d-flex align-items-center w-100">
                                            <img
                                                src="/assets/images/flags/flag1.png"
                                                alt=""
                                                className="w-40-px h-40-px rounded-circle flex-shrink-0 me-12"
                                            />
                                            <div className="flex-grow-1">
                                                <h6 className="text-sm mb-0">{item.name}</h6>
                                                <span className="text-xs text-secondary-light fw-medium">
                                                    {item.value} Users
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                ))
                            ) : (
                                <div className="text-center text-secondary">No country data available</div>
                            )
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default DistributionMapsOne;

